module.exports = __webpack_public_path__ + "img/var_03_frame.1e346428.png";